
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import ErrorBoundary from './components/ErrorBoundary.tsx';

// --- Service Worker Registration ---
// To combat the persistent "The document is in an invalid state" error, we are
// employing a robust, two-stage deferral. First, we wait for the 'load' event.
// Second, we use a `setTimeout` to push the registration call to the next
// macro-task in the event loop. This ensures that the browser has finished
// all its 'load' event processing and the document state is fully stabilized
// before we attempt the security-sensitive Service Worker registration. This is
// an effective, if slightly delayed, strategy for tricky sandboxed environments.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // A small delay can help in complex environments.
    setTimeout(() => {
      const swUrl = `${window.location.origin}/sw.js`;
      navigator.serviceWorker.register(swUrl)
        .then(registration => {
          console.log('Service Worker registered with scope:', registration.scope);
        })
        .catch(error => {
          console.error('Service Worker registration failed:', error);
        });
    }, 100); // 100ms delay to ensure document state is stable.
  });
}


const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);